/* --------------------------------------------------------------------------------------
   xwSpinBox.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
export class xwSpinBox {
  /*@ngInject*/
  constructor(appSettings) {
    this.restrict = "A";
    (this.require = "?ngModel"),
      (this.scope = {
        ngModel: "=",
        onChange: "&",
        onMin: "&",
        onMax: "&",
      });
    this.appSettings = appSettings;
  }
  link(scope, elem, attrs, ngModel) {
    var options = this.getOptions(attrs, scope);

    options.change = () => this.change(elem, scope, attrs, ngModel);
    elem.first().xrxspinbox(options);
  }
  change(elem, scope, attrs, model) {
    const value = elem.first().xrxspinbox("value");
    model.$setViewValue(value);
    if (attrs.min == value.toString()) scope.onMin();
    if (attrs.max == value.toString()) scope.onMax();
    scope.onChange();
  }
  getOptions(attrs, scope) {
    return {
      theme: attrs.theme ? attrs.theme : this.appSettings.primaryColor,
      themePrimary: attrs.themePrimary == "true",
      widgetSize: attrs.widgetSize,
      initialValue: scope.ngModel,
      min: attrs.min,
      max: attrs.max,
    };
  }
  static directiveFactory(appSettings) {
    xwSpinBox.instance = new xwSpinBox(appSettings);
    return xwSpinBox.instance;
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwSpinBox.directive.js